// extracted by mini-css-extract-plugin
export default {"newMenu":"Newmenu_newMenu__-EchY","link":"Newmenu_link__XbijD","linkEmpty":"Newmenu_linkEmpty__yqLLc"};